var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b06d25;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-7 {\n        fill: #5b3822;\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-9 {\n        fill: #cbba73;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 6.7,
    y1: 262.8,
    x2: 228.9,
    y2: 262.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f89f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 117.8,
    y1: 173.1,
    x2: 117.8,
    y2: 217.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecb488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fccc9d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 162.7,
    y1: 93.7,
    x2: 88.4,
    y2: 114.2,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 173.3,
    y1: 328.5,
    x2: 276.8,
    y2: 254.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55849c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a9ab2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 226.1,
    y1: 171.3,
    x2: 226.1,
    y2: 216.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eab286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faca9b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 226.1,
    y1: 82.3,
    x2: 226.1,
    y2: 117.8,
    xlinkHref: "#linear-gradient-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "200.3 244 35.2 244 45.6 112.8 47.2 90.5 188.3 90.5 191.9 136.4 200.3 244"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.9,311.7c0,6.1-.4,12-1.3,17.8H8c-.9-5.8-1.3-11.8-1.3-17.8,0-63.9,49.7-115.7,111.1-115.7s111.2,51.8,111.2,115.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M80,212l37.8-82.6,37.8,82.6s-13.1,27.4-37.8,27.4-37.8-27.4-37.8-27.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M188.4,94.6c0,.8,0,1.7-.1,2.5-.2,8.9-2.2,18.5-5.3,28-10.6,32.4-35.8,64.1-65.2,64.1s-62.9-42.9-69.3-79.7c-.7-4.2-1.2-8.4-1.3-12.4-.1-.8-.1-1.7-.1-2.5s0-1.7.1-2.4c0-.6,0-1.2.1-1.7-.1-1,0-1.9.1-2.8.7-7.1,2.4-13.8,5.1-20.2,10.5-25.6,35.7-43.7,65.3-43.7s61.3,23.2,68.7,54.5c.5,1.9.8,3.8,1.1,5.9h0c.4,2,.6,4.1.6,6.3.1.5.1,1.1.1,1.7.1.7.1,1.6.1,2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M187.6,84.3h0c-7.7,2.6-14.9,4-21.2,6.3-26.1,9.4-42.9,4.2-55.9,0-.8-.4-1.6-.6-2.4-.8-17.8-5.8-28.4-16-47.9-8.5-3.8,1.4-8.1,3.6-12.7,6.6.7-7.1,2.4-13.8,5.1-20.2,10.5-25.6,35.7-43.7,65.3-43.7s61.3,23.2,68.7,54.5c.5,1.9.8,3.8,1.1,5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M62.3,80c-.6.2-1.3.6-2,1.2-2.3,1.9-4.7,5.3-6.7,9.4-2.9,5.7-5.2,12.7-4.9,19,.1.4.1.7.1,1.1l-3.1,2.2,1.7-22.3h.1c-.1-1,0-1.9.1-2.8.7-7.1,2.4-13.8,5.1-20.2,4.9,3.6,13.8,10.8,9.7,12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M191.9,136.4c-5.3.8-9.7-.4-9.1-7.9.1-1.1.1-2.2.2-3.2,1-15.2-.5-32.7-12.6-34.6-1.2-.1-2.5-.1-4,0l.4-7.5,14.8-6.3,4.9,1.6c.5,1.9.8,3.8,1.1,5.9h0c.4,2,.6,4.1.6,6.3h.1l3.6,45.8Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M343.3,311.5c0,6.1-.5,12.2-1.3,18H110.3c-.9-5.9-1.3-11.9-1.3-18,0-64.6,55.1-117,117.1-117,62.2,0,117.2,52.4,117.2,117Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M187.9,210.7l38.2-83.6,38.2,83.6s-13.3,27.8-38.2,27.8-38.2-27.8-38.2-27.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M297.6,91.9c0,.9,0,1.7-.1,2.6-.2,9-2.2,18.7-5.4,28.3-10.7,32.7-36.3,64.8-65.9,64.8-34.5,0-63.3-42.9-70-80h0c0-.2,0-.4-.1-.6-.7-4.3-1.2-8.5-1.3-12.5-.1-.8-.1-1.7-.1-2.6,0-.8,0-1.7.1-2.4,0-.6,0-1.2.1-1.7-.1-1,0-1.9.1-2.8.7-7.2,2.4-14,5.1-20.4,10.6-25.9,36.1-44.2,66.1-44.2,33.8,0,62,23.5,69.5,55.1.5,1.9.9,3.9,1.1,6h0c.4,2.1.6,4.1.6,6.3.1.5.1,1.1.1,1.7.1.7.1,1.6.1,2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M156.2,107.6c0-.2,0-.4-.1-.6,0,.2,0,.4.1.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.7,81.5h0c-7.8,2.7-15.1,4-21.4,6.3-26.4,9.5-43.4,4.3-56.6,0-.9-.4-1.6-.6-2.4-.9-18-5.8-28.7-16.2-48.4-8.6-3.9,1.5-8.2,3.6-12.9,6.7.7-7.2,2.4-14,5.1-20.4,10.6-25.9,36.1-44.2,66.1-44.2,33.8,0,62,23.5,69.5,55.1.5,1.9.9,3.9,1.1,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170,77.1c-.6.2-1.3.6-2.1,1.2-2.3,1.9-4.7,5.4-6.8,9.5-2.9,5.7-5.2,12.9-5,19.2-.7-4.3-1.2-8.5-1.3-12.5-.1-.8-.1-1.7-.1-2.6,0-.8,0-1.7.1-2.4,0-.6,0-1.2.1-1.7-.1-1,0-1.9.1-2.8.7-7.2,2.4-14,5.1-20.4,5,3.6,14,11,9.9,12.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.6,91.9c0,.9,0,1.7-.1,2.6-.2,9-2.2,18.7-5.4,28.3,1-15.3-.5-33.1-12.8-35-1.2-.1-2.6-.1-4,0l.4-7.5,15-6.3,5,1.6c.5,1.9.9,3.9,1.1,6h0c.4,2.1.6,4.1.6,6.3.1.5.1,1.1.1,1.7.1.7.1,1.6.1,2.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default __webpack_public_path__ + "static/media/accounts.3729cca75deddaa448d176b193a32bb6.svg";
export { ForwardRef as ReactComponent };